import apiFetch from '../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `Ciaro/updateOrderCiaro`, method: 'POST', body: values, token: token})
}